jQuery(document).ready(function() {
    jQuery('.box_video_wrapper').each(function() {
        var $wrapper = jQuery(this);
        var $link = $wrapper.find('a');
        var $img = $link.find('img.bg');
        var $videoLoader = $link.find('.video-loader');
        var $progress = $link.find('.video-progress');
        var $progressBar = $progress.find('.progress-bar');
        var $videoContainer = jQuery('<div class="video-container w-100 h-100 position-absolute top-0 start-0" style="opacity: 0;"></div>');
        var video = document.createElement('video');
        
        $link.append($videoContainer); 
        
        $link.on('mouseenter', function() {
            var videoUrl = $img.data('video');
            if (videoUrl) {
                $videoLoader.css('opacity', '1');
                $progress.css('opacity', '1');
                
                video.src = videoUrl;
                video.muted = true;
                video.playsinline = true;
                
                var startTime = Date.now();
                var loadingInterval = setInterval(function() {
                    var elapsedTime = Date.now() - startTime;
                    var progress = Math.min((elapsedTime / 2000) * 100, 100);
                    $progressBar.css('width', progress + '%').attr('aria-valuenow', progress);
                    
                    if (video.readyState >= 3 && elapsedTime >= 2000) {
                        clearInterval(loadingInterval);
                        $videoLoader.css('opacity', '0');
                        $progress.css('opacity', '0');
                        $img.css('opacity', '0');
                        jQuery(video).addClass('w-100 object-fit-cover').appendTo($videoContainer);
                        $videoContainer.css('opacity', '1');
                        video.play();
                    }
                }, 50);
            }
        }).on('mouseleave', function() {
            $img.css('opacity', '1');
            $videoContainer.css('opacity', '0').empty();
            $progress.css('opacity', '0');
            $progressBar.css('width', '0%').attr('aria-valuenow', 0);
            $videoLoader.css('opacity', '0');
        });
    });
});